import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { useNotifications } from "../../../contexts/notificationContext";
import { useTranslations } from "../../../contexts/translationContext";
import ItemSearchResult from "../../../models/ItemSearchResult";
import DataService from "../../../services/data.service";
import { ProjectPopupProps } from "../../../types/PopupProps";
import ItemSearchMiniView from "../../Search/ItemMini";

interface Props {
    show: boolean
    onHide: (itemSearchResult?: ItemSearchResult) => void
    productCategoryId: number
    backgroundType: string
}
interface ProjectItemRevisionCreateModel {
    projectId: number
    itemRevisionId: number
}

const SelectBackgroundGraphicPopup: React.FC<Props> = ({ show, onHide, productCategoryId, backgroundType }) => {
    const [title, setTitle] = useState<string>();
    const { translate } = useTranslations();

    useEffect(() => {
        translate('Select ' + backgroundType).then(translated => setTitle(translated));
    }, [backgroundType]);

    function handleItemclicked(itemRevision: ItemSearchResult) {
        onHide(itemRevision)
    }

    return (
        <Modal show={show} onHide={onHide} size="xl">
            <Modal.Header closeButton>
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <ItemSearchMiniView handleItemClicked={handleItemclicked} productCategoryId={productCategoryId} forBom={false} />
            </Modal.Body>
        </Modal>
    );
}
export default SelectBackgroundGraphicPopup;